import src from "IMAGE";
export default { src, width: 270, height: 55, blurWidth: 0, blurHeight: 0};
